import React from "react";
import Logo from "./assets/img/logo-light.svg";
import Image from "./assets/img/book.png";
import { Link, Redirect, Route } from "react-router-dom";


import axios from "axios";
import swal from "sweetalert";
import $ from "jquery";

const Register = () => {
  let _fname, _lname, _email, _phone;

  const handleRegistration = (e) => {
    e.preventDefault();


    $("#login-form button")
      .attr("disabled", "disabled")
      .html(
        '<i class="fa fa-spinner fa-spin fa-1x fa-fw"></i><span>Loading...</span>'
      );

    var formData = new FormData();
    formData.append("firstname", _fname.value);
    formData.append("lastname", _lname.value);
    formData.append("email", _email.value);
    formData.append("phone", _phone.value);

    axios({
      method: "post",
      url: `${axios.defaults.baseURL}/event-register`,
      data: formData,
      headers: {
        'Access-Control-Allow-Origin':'*'
      }
    })
      .then((response) => {
        //console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          swal("Success!", "" + json.data.message, "success", {
            button: false,
            timer: 1500,
          });
          window.location.reload(); 
        } else {
          swal("Failed", "" + json.data.message, "error");
        }
      })
      .catch((error) => {
        let res = "An Error Occured";
        swal("Error!", "" + res, "error", {
          button: false,
          // timer: 1500
        });
      });
  };

  return (
    <main className="login-body d-flex align-items-center min-vh-100 py-3 py-md-0">
      <div className="container">
        <div className="card login-card">
          <div className="row no-gutters">
            <div className="col-md-5">
              <img src={Image} alt="login" className="login-card-img" />
            </div>
            <div className="col-md-7">
              <div className="card-body">
                  {/* <div className="brand-wrapper">
                    <img src={Logo} alt="logo" className="logo" />
                  </div> */}
                <p className="login-card-description">UNFINISHED GREATNESS<br/><span style={{fontSize:14}}>Envisioning a New Nigeria - by <b>Kayode Fayemi</b></span></p>
                <p className="login-card-description">Welcome, Please Register!</p> 
                <form id="login-form" onSubmit={handleRegistration} method="post">
                  <div className="form-group mt-3">
                    <label for="firstname" className="sr-only">
                      Firstname
                    </label>
                    <input
                      ref={(input) => (_fname = input)}
                      type="firstname"
                      name="firstname"
                      id="firstname"
                      className="form-control"
                      placeholder="Firstname"
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label for="lastname" className="sr-only">
                      Lastname
                    </label>
                    <input
                      ref={(input) => (_lname = input)}
                      type="lastname"
                      name="lastname"
                      id="lastname"
                      className="form-control"
                      placeholder="Lastname"
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label for="email" className="sr-only">
                      Email
                    </label>
                    <input
                      ref={(input) => (_email = input)}
                      type="email"
                      name="email"
                      id="email"
                      className="form-control"
                      placeholder="Email address"
                    />
                  </div>
                  <div className="form-group">
                    <label for="telephone" className="sr-only">
                      Telephone
                    </label>
                    <input
                      ref={(input) => (_phone = input)}
                      type="telephone"
                      name="telephone"
                      id="telephone"
                      className="form-control"
                      placeholder="Telephone"
                    />
                  </div>
                  <br/> 
                  <button
                    type="submit"
                    className="btn btn-block login-btn mb-4"
                  >
                    Submit
                  </button>
                </form>
                <p className="login-card-footer-text">
                  This data is solely for record purpose!{" "}
                </p>
                <nav className="login-card-footer-nav">
                  <Link to="https://hipheckts.ng">
                    Powered by Hipheckts' Technologies
                  </Link>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};
export default Register;
